export default __webpack_public_path__ + "static/media/terms-of-service-consent-en-4.3ca1a70b.jpg";